"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME = void 0;
const TIME = {
  now: () => Date.now(),
  ms: {
    SECOND: 1000,
    MINUTE: 1000 * 60,
    HOUR: 1000 * 60 * 60,
    DAY: 1000 * 60 * 60 * 24,
    WEEK: 1000 * 60 * 60 * 24 * 7,
    MONTH: 1000 * 60 * 60 * 24 * 30,
    YEAR: 1000 * 60 * 60 * 24 * 365
  },
  s: {
    SECOND: 1,
    MINUTE: 60,
    HOUR: 60 * 60,
    DAY: 60 * 60 * 24,
    WEEK: 60 * 60 * 24 * 7,
    MONTH: 60 * 60 * 24 * 30,
    YEAR: 60 * 60 * 24 * 365
  },
  m: {
    SECOND: 1 / 60,
    MINUTE: 1,
    HOUR: 60,
    DAY: 60 * 24,
    WEEK: 60 * 24 * 7,
    MONTH: 60 * 24 * 30,
    YEAR: 60 * 24 * 365
  }
};
exports.TIME = TIME;